// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__HVBu8","content":"Modal_content__nwUTA"};